export function generateItemId(baseId, itemNamespace) {
    return "".concat(baseId, "-").concat(itemNamespace);
}
